// In Next.js, this file would be called: app/providers.tsx
'use client';

import getQueryClient from '@/lib/get-query-client';
import { QueryClientProvider } from '@tanstack/react-query';
import { Provider as RollbarProvider } from '@rollbar/react';
import { clientConfig } from '@/rollbar';
import Rollbar from 'rollbar';

export default function Providers({ children }: { children: React.ReactNode }) {
  const queryClient = getQueryClient();

  const rollbar = new Rollbar(clientConfig);

  return (
    <RollbarProvider instance={rollbar}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </RollbarProvider>
  );
}
